const Strings = {
  en_CA: {
    // Common Verbs
    add: 'Add',
    archive: 'Archive',
    close: 'Close',
    copy: 'Copy',
    create: 'Create',
    delete: 'Delete',
    edit: 'Edit',
    hide: 'Hide',
    manage: 'Manage',
    order_by: 'Order By',
    search: 'Search',
    submit: 'Submit',
    purchase: 'Purchase',
    free: 'Free',

    // Entities
    questions: 'Questions',
    revision_abbr: 'Rev.',

    // Fields
    confirm_password: 'Confirm Password',
    email: 'Email',
    email_address: 'Email Address',
    name: 'Name',
    name_placeholder: 'Enter your full name',
    phone: 'Phone',
    phone_placeholder: '+1 (555) 555-1212',
    password: 'Password',
    title: 'Title',
    date: 'Date',

    login: {
      title: 'Log In',
      send_request: 'Log In',
      in_progress: 'Requesting log in...',
      request_reset: 'Click here if you forgot your password.',
      request_account: 'Click here to create an account with Continuous Coaching',
      accept_eula: 'I accept the terms of this agreement',
    },

    start_investigation: {
      send_request: 'Mail Questionnaire',
      in_progress: 'Processing...',
      failed: 'Failed to send investigation'
    },
    password_reset: {
      title: 'Request to Reset Your Password',
      instructions: '<p>Enter your email address below and click "Request password reset".</p>',
      send_request: 'Request password reset',
      in_progress: 'Sending request...',
      complete: 'You have been sent an email containing information required to reset your password.'
    },
    password_update: {
      title: 'Password Update',
      instructions: '<p>Enter your new password below.</p>',
      new_password: 'New Password',
      confirm_password: 'Confirm New Password',
      send_request: 'Request password update',
      in_progress: 'Updating password...',
      complete: 'Your password has been updated. Keep it safe!',
      fail: 'Unable to update your password'
    },
    account_request: {
      title: 'Request Account',
      send_request: 'Request account',
      in_progress: 'Sending request...',
      fail: 'Unable to request account.',
      invalid: 'Invalid email entered, account request not made',
      complete: 'You have been sent an email containing next steps for signing up.'
    },
    account_finalize: {
      title: 'Finalize Account',
      send_request: 'Finalize account',
      in_progress: 'Sending request...',
      complete: 'Account created successfully! Log in with the email and password you just set to accept your invitations and start getting coached!',
      fail: 'Unable to finalize account.',
      invalid: 'There is no account creation request associated with this link. Maybe you created your account already, or need to make another request?',
      submit: 'Save my information and continue'
    },
    coachee_inviter: {
      success: 'Your invitation has been sent! It will expire after 72 hours, after which you may send a new invitation'
    },
    questionnaires: {
      title: 'Questionnaires'
    },
    questionnaires_in_workspace: {
      title: 'Available Questionnaires'
    },
    workspaces: {
      workspace_archived: 'Workspace archived successfully.',
      is_member: 'Participant',
      is_owner: 'Owner',
      title: 'Workspaces',
      new_workspace_name: 'New Workspace Name',
      archive_confirmation: 'Are you sure you want to archive this workspace?'
    }
  }
};

export default Strings;
